import React, {useEffect} from 'react';
import * as S from './PanUploader.styles';

import IconSelector from '@ibibo/icon-selector';

export const PanUploader = ({cancelEvent, agreeEvent, imgSrc}) => {
    useEffect(() => {
        window.scrollTo(0,0);
    },[]);
    return(
        <S.PopupMainWrapper>
            <S.PopupHeadWrap>
                <S.PopupHeadTextWrap>
                    <S.PopupHeadText>Verify Uploaded Pan</S.PopupHeadText>
                </S.PopupHeadTextWrap>
                <S.PopupHeadCloseWrap>
                    <S.PopupCloseBtn onClick={cancelEvent}>
                        <IconSelector iconKey='close' />
                    </S.PopupCloseBtn>
                </S.PopupHeadCloseWrap>
            </S.PopupHeadWrap>
            <S.PopupBodyWrapper>
                <S.PopupContentWrap>
                    <img src={imgSrc} alt="uploded pan" width="100%" height="auto" />
                </S.PopupContentWrap>

                <S.ButtonWrapper>
                    <S.CancelBtn onClick={cancelEvent}>Upload New Pan</S.CancelBtn>
                    <S.AgreeBtn onClick={agreeEvent}>Continue</S.AgreeBtn>
                </S.ButtonWrapper> 
            </S.PopupBodyWrapper>
            
        </S.PopupMainWrapper>
    );
}

export const KYCUploader = ({cancelEvent, agreeEvent, imgSrc}) => {
    useEffect(() => {
        window.scrollTo(0,0);
    },[]);
    return(
        <S.PopupMainWrapper>
            <S.PopupHeadWrap>
                <S.PopupHeadTextWrap>
                    <S.PopupHeadText>Verify Uploaded KYC Document</S.PopupHeadText>
                </S.PopupHeadTextWrap>
                <S.PopupHeadCloseWrap>
                    <S.PopupCloseBtn onClick={cancelEvent}>
                        <IconSelector iconKey='close' />
                    </S.PopupCloseBtn>
                </S.PopupHeadCloseWrap>
            </S.PopupHeadWrap>
            <S.PopupBodyWrapper>
                <S.PopupContentWrap>
                    <img src={imgSrc} alt="uploded KYC Document" width="100%" height="auto" />
                </S.PopupContentWrap>

                <S.ButtonWrapper>
                    <S.CancelBtn onClick={cancelEvent}>Upload New Document</S.CancelBtn>
                    <S.AgreeBtn onClick={agreeEvent}>Continue</S.AgreeBtn>
                </S.ButtonWrapper> 
            </S.PopupBodyWrapper>
            
        </S.PopupMainWrapper>
    );
}

export const FacadeUploader = ({cancelEvent, agreeEvent, imgSrc}) => {
    useEffect(() => {
        window.scrollTo(0,0);
    },[]);
    return(
        <S.PopupMainWrapper>
            <S.PopupHeadWrap>
                <S.PopupHeadTextWrap>
                    <S.PopupHeadText>Verify Uploaded Document</S.PopupHeadText>
                </S.PopupHeadTextWrap>
                <S.PopupHeadCloseWrap>
                    <S.PopupCloseBtn onClick={cancelEvent}>
                        <IconSelector iconKey='close' />
                    </S.PopupCloseBtn>
                </S.PopupHeadCloseWrap>
            </S.PopupHeadWrap>
            <S.PopupBodyWrapper>
                <S.PopupContentWrap>
                    <img src={imgSrc} alt="uploded document image" width="100%" height="auto" />
                </S.PopupContentWrap>

                <S.ButtonWrapper>
                    <S.CancelBtn onClick={cancelEvent}>Upload New Image</S.CancelBtn>
                    <S.AgreeBtn onClick={agreeEvent}>Continue</S.AgreeBtn>
                </S.ButtonWrapper> 
            </S.PopupBodyWrapper>
            
        </S.PopupMainWrapper>
    );
}

export const NameCorrectSelect = ({cancelEvent, agreeEvent, msg}) => {
    useEffect(() => {
        window.scrollTo(0,0);
    },[]);
    return(
        <S.PopupNameCorrect>
            <S.PopupHeadWrap>
                <S.PopupHeadTextWrap>
                    <S.PopupHeadText>PAN Name Verification</S.PopupHeadText>
                </S.PopupHeadTextWrap>
                <S.PopupHeadCloseWrap>
                    <S.PopupCloseBtn onClick={cancelEvent}>
                        <IconSelector iconKey='close' />
                    </S.PopupCloseBtn>
                </S.PopupHeadCloseWrap>
            </S.PopupHeadWrap>
            <S.PopupBodyWrapper>
                <S.PopupContentNameWrap>
                    <S.PopupNameInfoText>{msg}</S.PopupNameInfoText>
                </S.PopupContentNameWrap>

                <S.ButtonWrapper>
                    <S.CancelBtn onClick={cancelEvent}>Upload New PAN</S.CancelBtn>
                    <S.AgreeBtn onClick={agreeEvent}>Confirm Name</S.AgreeBtn>
                </S.ButtonWrapper> 
            </S.PopupBodyWrapper>
            
        </S.PopupNameCorrect>
    );
}